import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';
import PasswordInput from '../../Global/Forms/PasswordInput';
import PasswordRequirements from '../../Global/Forms/PasswordRequirements';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const ChangePasswordForm = ({
  submitting,
  // Formik props
  values,
  errors,
  touched,
  handleChange,
}) => {
  const hasFormChanged = () => {
    if (!values.password) {
      return false;
    }
    return true;
  };

  return (
    <Form className="m-b-5">
      <h3 className="like-h3 m-b-3">Change password</h3>

      <fieldset className="m-b-5">
        <div className="m-b-5">
          <PasswordInput
            name="password"
            label="Current password"
            maxLength={100}
            value={values.password}
            onChange={handleChange}
            error={errors.password}
            touched={touched.password}
            required
          />
        </div>

        <PasswordRequirements value={values.newPassword} />

        <div className="row">
          <div className="col-lg-6">
            <PasswordInput
              name="newPassword"
              label="New password"
              maxLength={100}
              value={values.newPassword}
              onChange={handleChange}
              error={errors.newPassword}
              touched={touched.newPassword}
              required
            />
          </div>

          <div className="col-lg-6">
            <PasswordInput
              name="confirmNewPassword"
              label="Confirm new password"
              maxLength={100}
              value={values.confirmNewPassword}
              onChange={handleChange}
              error={errors.confirmNewPassword}
              touched={touched.confirmNewPassword}
              required
            />
          </div>
        </div>

        <div className="text-right form-group">
          <Button type="submit" loading={submitting} disabled={hasFormChanged() === false}>Change password</Button>
        </div>
      </fieldset>
    </Form>
  );
};

ChangePasswordForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikChangePasswordForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues() {
    return {
      password: ``,
      newPassword: ``,
      confirmNewPassword: ``,
    };
  },
  validationSchema: Yup.object().shape({
    // We don't add full validation onto the current password as people who signed up before the new plans may not have a password
    // password that satisfies the new requirements
    password: Yup.string()
      .label(`Password`)
      .required(),
    newPassword: Yup.string()
      .label(`New password`)
      .min(8, `Must be at least 8 characters`)
      .matches(/[A-Z]/, `Must contain an uppercase letter`)
      .matches(/[a-z]/, `Must contain a lowercase letter`)
      .matches(/[0-9]/, `Must contain a number`)
      .required(),
    confirmNewPassword: Yup.string()
      .label(`Confirm new password`)
      .oneOf([Yup.ref(`newPassword`)], `Must match your new password`)
      .required(),
  }),
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
    bag.resetForm();
  },
})(ChangePasswordForm);

export default FormikChangePasswordForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/ChangePasswordForm.js